import {
  redux_getAllContactRequests,
  redux_getContactRequest,
  redux_updateContactRequest,
  redux_createContactRequest,
  redux_contactRequestActionStarts,
  redux_contactRequestActionErrors,
  redux_resetContactRequestErrors,
} from '../../core/data/redux/modules/contactRequest/actions';

import { Dispatch } from 'redux';
import { makeApiRequest } from '../../utils/api-utils';

export const getAllContactRequests = () => async (dispatch: Dispatch) => {
  dispatch(redux_contactRequestActionStarts());
  try {
    const response = await makeApiRequest(`/contact-requests/get-all`);
    const responseDto = response;
    if (responseDto.error) {
      dispatch(redux_contactRequestActionErrors(responseDto.error));
    } else {
      dispatch(redux_getAllContactRequests(responseDto.data));
    }
  } catch (error) {
    dispatch(redux_contactRequestActionErrors((error as any)?.message || 'Error fetching contact requests'));
  }
};

export const getContactRequestById = (id: string) => async (dispatch: Dispatch) => {
  dispatch(redux_contactRequestActionStarts());
  try {
    const response = await makeApiRequest(`/contact-requests/get/${id}`);
    const responseDto = response;
    if (responseDto.error) {
      dispatch(redux_contactRequestActionErrors(responseDto.error));
    } else {
      dispatch(redux_getContactRequest(responseDto.data));
    }
  } catch (error) {
    dispatch(redux_contactRequestActionErrors((error as any)?.message || 'Error fetching contact request'));
  }
};

export const createContactRequest = (contactRequestData: any, setModalOpen?: (value: boolean) => void) => async (dispatch: Dispatch) => {
  dispatch(redux_contactRequestActionStarts());
  try {
    const response = await makeApiRequest(`/contact-requests/add`, {
      method: 'POST',
      body: JSON.stringify(contactRequestData),
    });

    const responseDto = response;
    if (responseDto.error) {
      dispatch(redux_contactRequestActionErrors(responseDto.error));
    } else {
      dispatch(redux_createContactRequest(responseDto.data));
      if (setModalOpen) {
        setModalOpen(false);
      }
    }
  } catch (error) {
    dispatch(redux_contactRequestActionErrors((error as any)?.message || 'Error creating contact request'));
  }
};

export const updateContactRequest = (id: string, contactRequestData: any, setModalOpen?: (value: boolean) => void) => async (dispatch: Dispatch) => {
  dispatch(redux_contactRequestActionStarts());
  try {
    const response = await makeApiRequest(`/contact-requests/update/${id}`, {
      method: 'PUT',
      body: JSON.stringify(contactRequestData),
    });

    const responseDto = response;
    if (responseDto.error) {
      dispatch(redux_contactRequestActionErrors(responseDto.error));
    } else {
      dispatch(redux_updateContactRequest(responseDto.data));
      if (setModalOpen) {
        setModalOpen(false);
      }
    }
  } catch (error) {
    dispatch(redux_contactRequestActionErrors((error as any)?.message || 'Error updating contact request'));
  }
};

export const deleteContactRequest = (id: string) => async (dispatch: Dispatch) => {
  dispatch(redux_contactRequestActionStarts());
  try {
    const response = await makeApiRequest(`/contact-requests/delete/${id}`, {
      method: 'DELETE',
    });

    const responseDto = response;
    if (responseDto.error) {
      dispatch(redux_contactRequestActionErrors(responseDto.error));
    }
  } catch (error) {
    dispatch(redux_contactRequestActionErrors((error as any)?.message || 'Error deleting contact request'));
  }
};

export const getUnreadContactRequestCount = () => async (dispatch: Dispatch) => {
  dispatch(redux_contactRequestActionStarts());
  try {
    const response = await makeApiRequest(`/contact-requests/unread-count`);
    const responseDto = response;
    if (responseDto.error) {
      dispatch(redux_contactRequestActionErrors(responseDto.error));
    } else {
      return responseDto.data;
    }
  } catch (error) {
    dispatch(redux_contactRequestActionErrors((error as any)?.message || 'Error fetching unread contact request count'));
  }
}; 